export const legacyRoutes = {
  list: '/admin/legacy-code-history',
  add: '/admin/legacy-code-history/add',
  edit: '/admin/legacy-code-history/:itemId',
  getEditLink: (itemId: string) => `/admin/legacy-code-history/${itemId}`,
};
